
import React, { Component } from 'react';
import './assign-coordinator.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
// import CommonApi from '../../../apis/common'
import { ImageConstants, } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import SessionCache from '../../routes/session-cache';

class AssignCoordinator extends Component {
    constructor(props) {
        super(props)
        this.state.selectedEvent = this.props.selectedEvent;
        const selectedUsers = []
        if(this.props.coordinators?.length) {
            this.props.coordinators.findIndex(user => {
                if(user.events && user.events.includes(this.state.selectedEvent?._id)) {
                    selectedUsers.push(user._id)
                }
            })
        }
        this.state.selectedUsers = selectedUsers
        this.state.existingUsers = selectedUsers
    }

    state = {
        existingUsers: [],
        types: [],
        title: "ASSIGN COORDINATOR",
        selectedUsers: [],
        selectedUser: null,
        existingUsersDropdown: []
    }

    userHash = {}

    componentDidMount() {
        this.getStaffs()
    }

    getStaffs(payload = {}) {
        // payload.types= "in/COORDINATOR"
        SchoolApi.getStaffs(payload)
            .then(response => {
                let items = [];
                this.userHash = {}
                for (let i = 0; i < response?.response?.length; i++) {
                    items.push({
                        title: response?.response[i].firstName,
                        value: response?.response[i]._id,
                    })
                    this.userHash[response?.response[i]._id] = response?.response[i]
                }

                this.setState({ existingUsersDropdown: items, showDropdown: true })
            }).catch(err => {
            })
    }

    onSave() {
        const { selectedEvent, selectedUsers, existingUsers, isSubmit } = this.state
        if (!selectedUsers?.length || isSubmit == true) return
        const payload = {staffs: selectedUsers, eventId: selectedEvent._id}
        
        this.setState({ isSubmit: true })

        SchoolApi.updateEventsToCoordinator(payload).then(response => {
            let user = SessionCache.getUser()
            if(!user.schoolInfo?.eventParticipated) user.schoolInfo.eventParticipated = []
            const idx = user.schoolInfo.eventParticipated.findIndex(ep => ep.eventId === selectedEvent._id)
            if(idx < 0) {
                user.schoolInfo.eventParticipated.push({eventId: selectedEvent._id})
                SessionCache.setUser(user)
            }
            this.props.onClose()
            this.setState({ isSubmit: false })
        }).catch(err => {
            this.setState({ isSubmit: false })
        })
    }

    validatePayload(payload) {
        return true
    }

    addNewCoordinator = () => {
        this.props.delegate && this.props.showAddCoordinator && this.props.showAddCoordinator({}, 'CREATE');
    }

    onSelectUser = (options) => {
        if (options?.length) {
            const selectedUsers = []
            options.map(o => selectedUsers.push(o.value))
            this.setState({ selectedUsers })
        }
    }

    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={this.props.show} toggle={this.props.onClose} size={this.props.size || 'md'}>
                <ModalBody >
                    <div className="assign-coordinator">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>
                        <div className="header-text text-center">
                            <span>{this.state.title}</span>
                            <span>{this.state.selectedUser?.title}</span>
                        </div>
                        <div className='row pt-5'>
                            <div className='col-2'></div>
                            <div className='col-8'>
                                {this.state.showDropdown &&
                                    <Dropdown
                                        key="users"
                                        placeholder='Select from the list'
                                        options={this.state.existingUsersDropdown}
                                        onSelect={(option) => this.onSelectUser(option)}
                                        text="title"
                                        style={{ background: "#F6F7F5" }}
                                        invalid={this.state.isSubmit && !this.state.selectedUsers?.length}
                                        multiSelect={true}
                                        value={this.state.selectedUsers}
                                    />
                                }
                            </div>
                            <div className='col-2 close-icon-wrapper'>
                                <img className="custom-close-icon cursor-pointer" onClick={this.addNewCoordinator} src={getImageSource(ImageConstants.ADD)} />
                            </div>
                        </div>
                        <div className="text-center pt-5">
                            {this.state.selectedUsers?.length ?
                                <button className="cw-button-primary" onClick={() => this.onSave()}>
                                    ASSIGN
                                </button>
                                :
                                <button className="cw-button-disabled" >
                                    ASSIGN
                                </button>
                            }
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default AssignCoordinator;